import i18n from '../../managers/i18n'

i18n.register(
  'zh-Hans',
  {
    clear: '清除',
    selectDate: '请选择日期',
    selectMonth: '请选择月份',
    selectYear: '请选择年份',
    selectRange: ['开始日期', '结束日期'],
    selectMonthRange: ['开始月份', '结束月份'],
    selectYearRange: ['开始年份', '结束年份']
  },
  {
    ns: 'datepicker'
  }
)
